import { render, staticRenderFns } from "./product_link.vue?vue&type=template&id=81449230&"
import script from "./product_link.vue?vue&type=script&lang=js&"
export * from "./product_link.vue?vue&type=script&lang=js&"
import style0 from "./product_link.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports